// supplier-webapp stores names in a varchar(100) column that counts every character.
export const BUSINESS_NAME_MAX_LENGTH = 100;

export const isBusinessNameTooLong = (name: string): boolean =>
  name.length > BUSINESS_NAME_MAX_LENGTH;
